import Schema from 'ia-react-core/~/schemas/Schema';
import SuffixSchema from 'ia-react-core/~/schemas/SuffixSchema';
import React from 'react';

export interface SchemaContextProps {
  schema: Schema;
}

const SchemaContext = React.createContext<SchemaContextProps>({
  schema: new SuffixSchema(),
});

export default SchemaContext;
